(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    class CartAccessories extends HTMLElement {
    connectedCallback() {
      this.addEventListener('submit', this.submit);
      this.addEventListener('click', this.navigate);
      this.addEventListener('scroll', this.scheduleDots, { capture: true, passive: true });
      this.observer = new MutationObserver(this.refreshDots);
      this.observer.observe(this, { childList: true, subtree: true });
      this.resizeObserver = new ResizeObserver(this.scheduleDots);
      this.resizeObserver.observe(this);
      this.refreshDots();
    }
    disconnectedCallback() {
      this.removeEventListener('submit', this.submit);
      this.removeEventListener('click', this.navigate);
      this.removeEventListener('scroll', this.scheduleDots, true);
      this.previewController?.abort();
      this.previewHelper = null;
      this.previewCache?.clear();
      cancelAnimationFrame(this.dotsFrame);
      this.dotsFrame = 0;
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }
    refreshDots = () => {
      const cards = [...this.querySelectorAll('.cart-accessories__card')];
      const dots = this.querySelector('.cart-accessories__dots');
      if (!dots) return;
      const signature = cards.map((card) => card.dataset.productId).join(',');
      if (dots.dataset.signature !== signature) {
        dots.dataset.signature = signature;
        dots.replaceChildren(...cards.map((card, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'cart-accessories__dot';
          button.dataset.index = String(index);
          button.setAttribute('aria-label', dots.dataset.label.replace('[index]', String(index + 1)).replace('[count]', String(cards.length)));
          return button;
        }));
      }
      dots.hidden = cards.length < 2;
      this.scheduleDots();
    };
    scheduleDots = () => {
      if (this.dotsFrame) return;
      this.dotsFrame = requestAnimationFrame(() => {
        this.dotsFrame = 0;
        this.updateDots();
      });
    };
    updateDots = () => {
      const list = this.querySelector('.cart-accessories__list');
      if (!list) return;
      const cards = [...list.children];
      const box = list.getBoundingClientRect();
      const center = box.left + box.width / 2;
      let active = 0;
      let nearest = Infinity;
      cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < nearest) { nearest = distance; active = index; }
      });
      this.querySelectorAll('.cart-accessories__dot').forEach((dot, index) => {
        const current = String(index === active);
        if (dot.getAttribute('aria-current') !== current) dot.setAttribute('aria-current', current);
      });
    };
    navigate = (event) => {
      const card = event.target.closest('.cart-accessories__card');
      if (card && this.contains(card) && !event.target.closest('form, button') &&
          matchMedia('(max-width: 749px)').matches &&
          !event.defaultPrevented && event.button === 0 &&
          !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        const link = event.target.closest('a[href]') || card.querySelector('.cart-accessories__title[href]');
        if (link && !link.hasAttribute('download') && (!link.target || link.target === '_self')) {
          event.preventDefault();
          this.openPreview(link);
          return;
        }
      }
      const dot = event.target.closest('.cart-accessories__dot');
      if (!dot || !this.contains(dot)) return;
      const list = this.querySelector('.cart-accessories__list');
      const dotCard = list?.children[Number(dot.dataset.index)];
      if (!dotCard) return;
      const box = list.getBoundingClientRect();
      const rect = dotCard.getBoundingClientRect();
      list.scrollBy({ left: rect.left + rect.width / 2 - box.left - box.width / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    openPreview = async (link) => {
      if (this.previewController || this.busy) return;
      const controller = new AbortController();
      this.previewController = controller;
      const status = this.querySelector('[role="status"]');
      const sourceDialog = this.closest('dialog');
      sourceDialog?.addEventListener('close', () => controller.abort(), { signal: controller.signal });
      link.setAttribute('aria-busy', 'true');
      status.textContent = '';
      status.removeAttribute('data-state');
      status.classList.add('visually-hidden');
      const isCurrent = () => this.isConnected && !controller.signal.aborted &&
        matchMedia('(max-width: 749px)').matches && (!sourceDialog || sourceDialog.open);
      try {
        const { QuickAddComponent } = await import('@theme/quick-add');
        if (!isCurrent()) return;
        const modal = document.getElementById('quick-add-dialog');
        if (!modal || typeof modal.showDialog !== 'function') throw new Error();
        if (modal.querySelector('dialog')?.open) return;
        if (!customElements.get('cart-accessories-preview')) {
          customElements.define('cart-accessories-preview', class extends QuickAddComponent {
            get productPageUrl() { return this.dataset.productUrl || ''; }
            async updateQuickAddModal(productGrid) {
              productGrid.querySelectorAll('.accelerated-checkout-block').forEach((element) => element.remove());
              await super.updateQuickAddModal(productGrid);
            }
          });
        }
        if (!this.previewHelper) {
          this.previewHelper = document.createElement('cart-accessories-preview');
          this.previewHelper.hidden = true;
          this.appendChild(this.previewHelper);
        }
        this.previewHelper.dataset.productUrl = link.href;
        this.previewHelper.dataset.productTitle = link.closest('li').querySelector('.cart-accessories__title').textContent.trim();
        this.previewCache ??= new Map();
        let grid = this.previewCache.get(link.href);
        if (!grid) {
          const response = await fetch(link.href, { signal: controller.signal });
          if (!response.ok) throw new Error();
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          grid = html.querySelector('[data-product-grid-content]');
          if (!grid) throw new Error();
          this.previewCache.set(link.href, grid);
        }
        if (!isCurrent()) return;
        await this.previewHelper.updateQuickAddModal(grid.cloneNode(true));
        if (!isCurrent()) return;
        modal.querySelectorAll('.product-details, .product-information__media').forEach((element) => {
          element.scrollTo({ top: 0, behavior: 'instant' });
        });
        const drawer = this.closest('theme-drawer');
        modal.querySelector('dialog').addEventListener('close', () => {
          if (drawer && !drawer.isOpen) return;
          const target = link.isConnected ? link : drawer?.querySelector('.theme-drawer__close-button');
          target?.focus({ preventScroll: true });
        }, { once: true });
        link.focus({ preventScroll: true });
        modal.showDialog();
      } catch (error) {
        if (controller.signal.aborted || !this.isConnected) return;
        status.classList.remove('visually-hidden');
        status.dataset.state = 'error';
        status.textContent = this.dataset.previewError;
      } finally {
        controller.abort();
        link.removeAttribute('aria-busy');
        if (this.previewController === controller) this.previewController = null;
      }
    };
    submit = async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      event.preventDefault();
      if (this.busy || this.previewController) return;
      this.busy = true;
      const buttons = [...this.querySelectorAll('form button')];
      const status = this.querySelector('[role="status"]');
      const hadFocus = form.contains(document.activeElement);
      const submitButton = form.querySelector('button[type="submit"]');
      submitButton?.setAttribute('aria-busy', 'true');
      buttons.forEach((button) => { button.disabled = true; });
      status.textContent = '';
      status.removeAttribute('data-state');
      status.classList.add('visually-hidden');
      this.setAttribute('aria-busy', 'true');
      let added = false;
      let pending;
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map((item) => item.dataset.sectionId).filter(Boolean))].slice(0, 5);
        const body = new FormData(form);
        body.set('sections', sectionIds.join(','));
        body.set('sections_url', window.location.pathname);
        pending = CartLinesUpdateEvent.createPromise();
        pending.promise.catch(() => {});
        this.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add', context: 'cart',
          lines: [{ merchandiseId: String(body.get('id')), quantity: 1 }],
          promise: pending.promise,
        }));
        const response = await fetch(Theme.routes.cart_add_url, { method: 'POST', body, headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        added = true;
        const cartResponse = await fetch(Theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(this.dataset.error);
        const cart = await cartResponse.json();
        pending.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { sections: result.sections, items: cart.items, itemCount: cart.item_count, source: 'cart-accessories', didError: false },
        });
        status.dataset.state = 'added';
        status.textContent = this.dataset.added;
        this.previewCache?.clear();
        form.closest('li').remove();
        if (!this.querySelector('li')) {
          this.hidden = true;
          if (hadFocus) this.closest('cart-items-component')?.querySelector('.cart__checkout-button')?.focus({ preventScroll: true });
        } else if (hadFocus) {
          this.querySelector('.cart-accessories__heading h2')?.focus({ preventScroll: true });
        }
      } catch (error) {
        pending?.reject(error);
        if (added) {
          window.location.assign(Theme.routes.cart_url);
          return;
        }
        status.classList.remove('visually-hidden');
        status.dataset.state = 'error';
        status.textContent = error.message || this.dataset.error;
      } finally {
        submitButton?.removeAttribute('aria-busy');
        this.busy = false;
        this.removeAttribute('aria-busy');
        buttons.forEach((button) => { button.disabled = false; });
      }
    };
  }
  if (!customElements.get('cart-accessories')) customElements.define('cart-accessories', CartAccessories);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pk-cart-shipping-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pk-shipping-bar')) {
    const PK_ICONS = {
      check:
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12.5 9.5 18 20 6" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    };

    // Marker positions along the track, by how many markers there are. These are fixed
    // positions, not positions proportional to the dollar thresholds: a literal proportional
    // layout pushed the first marker far to the right (62.5% for $75 of $120) and bunched the
    // rest against the end. The two-marker pair (28/72) was measured off the reference design
    // and is unchanged; three markers space evenly and stop short of both edges so a centered
    // label never overflows the track-wrap's padding. The fill within each segment still
    // reflects real progress toward that segment's threshold, and runs to 100% once the last
    // offer is reached.
    const MARKER_LAYOUT = { 1: [100], 2: [28, 72], 3: [20, 50, 80] };
    const MAX_MARKERS = 3;

    class PkShippingBar extends HTMLElement {
      static get observedAttributes() {
        return ['data-cart-total-cents', 'data-cart-item-count'];
      }

      connectedCallback() {
        this.render();

        // Shopify's cart drawer (Section Rendering API) re-renders the surrounding markup on
        // every add/change/remove and morphs the new server HTML onto the existing DOM. The
        // Liquid source for this element is always `<pk-shipping-bar ...></pk-shipping-bar>`
        // with NO children — all of the actual bar content is built client-side by this
        // script after mount. When the morph reconciles this element's children against that
        // empty server markup, it wipes out everything we built, and that wipe doesn't
        // reliably re-trigger attributeChangedCallback (attributes can be patched before or
        // after the children are cleared depending on the morph's internal order), so the bar
        // was disappearing on quantity changes instead of updating. A MutationObserver here
        // catches exactly that: if our children get cleared out from under us while the bar
        // still has real cart data to show, rebuild immediately. This is a no-op loop-safe
        // guard — re-rendering into an already-empty element doesn't mutate anything, so
        // legitimately-empty states (disabled, empty cart) don't bounce.
        if (!this._pkObserver) {
          this._pkObserver = new MutationObserver(() => {
            if (this.childElementCount === 0) {
              // A morph wiped our children out from under us. Any cached node references in
              // this._els are now detached from the document, so force a full skeleton rebuild
              // rather than trying to patch stale nodes.
              this._built = false;
              this._mode = null;
              this._els = null;
              this.render();
            }
          });
          this._pkObserver.observe(this, { childList: true });
        }
      }

      disconnectedCallback() {
        if (this._pkObserver) {
          this._pkObserver.disconnect();
          this._pkObserver = null;
        }
      }

      // One cart update patches BOTH observed attributes (cart total + item count) in the same
      // synchronous morph pass, which used to fire render() twice — and the first of those two
      // ran against a half-updated pair (e.g. the new total alongside the stale item count).
      // Removing the last line item was the worst case: total hit 0 while count still read 1,
      // so that first render drew a full "You're only $75.00 away" bar before the second render
      // saw count 0 and emptied it. Coalescing into a microtask gives exactly one render per
      // update, always with a consistent pair, and still runs before the next paint so nothing
      // flashes. The `oldValue === newValue` guard also drops the no-op renders that a morph
      // re-writing an unchanged attribute would otherwise trigger.
      attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue || !this.isConnected || this._renderQueued) return;
        this._renderQueued = true;
        Promise.resolve().then(() => {
          this._renderQueued = false;
          if (this.isConnected) this.render();
        });
      }

      // Builds the DOM skeleton once (or whenever the marker count actually changes) and caches
      // references to the nodes that get updated on every render. This is what lets the CSS
      // transitions on .pk-shipping-bar__fill (width) and .pk-shipping-bar__marker-dot
      // (background/border/color) actually animate: a transition can only animate a property
      // changing on the SAME element across frames, and replacing innerHTML on every cart
      // update destroys and recreates every node, silently defeating them. Rebuilding only when
      // the marker count changes (an offer enabled/disabled, or an external DOM wipe — never on
      // an ordinary cart-total change) also means routine updates are a handful of property
      // writes instead of an HTML string re-parse.
      _ensureSkeleton(count) {
        if (this._built && this._mode === count) return;

        const positions = MARKER_LAYOUT[count] || MARKER_LAYOUT[1];
        let markers = '';
        for (const pct of positions) {
          markers +=
            '<span class="pk-shipping-bar__marker-dot" style="left:' + pct + '%"></span>' +
            '<span class="pk-shipping-bar__marker-label" style="left:' + pct + '%"></span>';
        }

        this.innerHTML =
          '<p class="pk-shipping-bar__message"></p>' +
          '<div class="pk-shipping-bar__track-wrap">' +
          '<div class="pk-shipping-bar__track">' +
          '<div class="pk-shipping-bar__fill"></div>' +
          markers +
          '</div>' +
          '</div>';

        this._els = {
          message: this.querySelector('.pk-shipping-bar__message'),
          fill: this.querySelector('.pk-shipping-bar__fill'),
          dots: [...this.querySelectorAll('.pk-shipping-bar__marker-dot')],
          labels: [...this.querySelectorAll('.pk-shipping-bar__marker-label')],
        };
        this._built = true;
        this._mode = count;
        this.dataset.markers = String(count);
      }

      _setDot(dot, reached) {
        dot.classList.toggle('pk-shipping-bar__marker-dot--reached', reached);
        const icon = reached ? PK_ICONS.check : '';
        // Only touch the dot's own innerHTML (a tiny inline SVG), never the dot element
        // itself, so the dot node persists and its background-color/border-color/color
        // transitions keep animating.
        if (dot.innerHTML !== icon) dot.innerHTML = icon;
      }

      _clear() {
        if (this._built) {
          this.innerHTML = '';
          this._built = false;
          this._mode = null;
          this._els = null;
        }
        this.classList.remove('pk-shipping-bar--complete');
        this.removeAttribute('data-reached');
        this.removeAttribute('data-markers');
      }

      /**
       * Turns the server's offer list into the markers actually drawn: thresholds converted to
       * the buyer's currency, labels resolved (from their own data-offer-label-* attributes,
       * or computed for a percentage/amount reward), offers sharing a threshold merged into
       * one marker, and the result ordered by threshold.
       *
       * Ordering is the point. Offers used to be positional — offer 1 then offer 2 — which
       * silently broke the moment a store's offers weren't configured in ascending order: a
       * $50 gift alongside $75 free shipping failed the old `tier2 > tier1` test and collapsed
       * the whole bar to a single marker, dropping the gift from the bar entirely. Sorting
       * here means the bar reflects whatever ladder the store actually has, in the order a
       * buyer climbs it.
       */
      _offers(rate, fmt) {
        const ds = this.dataset;
        let raw;
        try {
          raw = JSON.parse(ds.offers || '[]');
        } catch (error) {
          return [];
        }
        if (!Array.isArray(raw)) return [];

        // A blank "Reward suffix text" setting is a legitimate choice (just "10%", no trailing
        // words), so append it only when it's actually set rather than leaving a dangling space.
        const suffix = (ds.rewardSuffix || '').trim();
        const withSuffix = (base) => (suffix ? base + ' ' + suffix : base);

        const resolved = [];
        for (const offer of raw) {
          // Per-market thresholds arrive already in the cart currency.
          const threshold = Math.round(Number(offer.t || 0) * (ds.thresholdsLocal === 'true' ? 1 : rate));
          // A zero or missing threshold has nothing to progress toward, and would divide by
          // zero in the fill maths below.
          if (!(threshold > 0)) continue;

          // Fixed labels arrive as their own escaped attributes rather than inside the JSON —
          // see the note beside the Liquid that builds this.
          const id = typeof offer.i === 'string' ? offer.i : '';
          const fixed = id && ds['offerLabel' + id.charAt(0).toUpperCase() + id.slice(1)];
          let label;
          if (fixed) label = fixed;
          else if (offer.p != null) label = withSuffix(offer.p + '%');
          else if (offer.a != null) label = withSuffix(fmt(Math.round(Number(offer.a) * rate)));
          else continue;

          resolved.push({ threshold, label });
        }

        resolved.sort((a, b) => a.threshold - b.threshold);

        // Two offers at the same threshold would stack two dots on the same spot with two
        // labels on top of each other. They unlock together, so they read as one checkpoint.
        const merged = [];
        for (const offer of resolved) {
          const previous = merged[merged.length - 1];
          if (previous && previous.threshold === offer.threshold) previous.label += ' + ' + offer.label;
          else merged.push(offer);
        }
        return merged.slice(0, MAX_MARKERS);
      }

      render() {
        const ds = this.dataset;
        const cartEmpty = parseInt(ds.cartItemCount || '0', 10) <= 0;

        if (ds.enable !== 'true' || cartEmpty) {
          this._clear();
          return;
        }

        const cartTotal = parseInt(ds.cartTotalCents || '0', 10);
        const rate =
          parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1') || 1;
        const currency =
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        // Format against the STORE's locale, not the buyer's browser language. Passing
        // `undefined` here meant the same buyer saw a different symbol and grouping depending on
        // their OS language settings, and diverged from every other price on the page (those are
        // rendered server-side by Liquid's `money` filter in the store's own locale/format).
        // `documentElement.lang` is the most specific source (it can carry a region, e.g. en-AU),
        // with Shopify.locale as the fallback.
        const locale = document.documentElement.lang || (window.Shopify && window.Shopify.locale) || undefined;

        const fmt = (cents) => {
          const amount = cents / 100;
          // `narrowSymbol` keeps this matching the storefront: with a plain 'symbol' display an
          // AUD store rendered as locale "en" shows "A$45.00" here while the cart subtotal three
          // lines below it (Liquid `money`) shows "$45.00" — the bar would be the only price on
          // the page wearing a currency prefix. narrowSymbol gives a bare "$" for both, matching
          // Shopify's own money format; buyers on other Markets currencies still have Shopify's
          // currency selector telling them which currency they're shopping in. Older engines
          // throw RangeError on the option, so fall back through 'symbol' and then a plain
          // number + code rather than letting the whole render die.
          try {
            return new Intl.NumberFormat(locale, {
              style: 'currency',
              currency,
              currencyDisplay: 'narrowSymbol',
            }).format(amount);
          } catch (e) {
            try {
              return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
            } catch (e2) {
              return amount.toFixed(2) + ' ' + currency;
            }
          }
        };

        const offers = this._offers(rate, fmt);
        if (!offers.length) {
          this._clear();
          return;
        }

        this._ensureSkeleton(offers.length);

        const positions = MARKER_LAYOUT[offers.length];
        const nextIndex = offers.findIndex((offer) => cartTotal < offer.threshold);
        const allReached = nextIndex === -1;

        let progressPercent;
        if (allReached) {
          // Once the last checkpoint is reached the fill runs all the way to the end of the
          // track, not just to the final marker's fixed position.
          progressPercent = 100;
        } else {
          const previousThreshold = nextIndex > 0 ? offers[nextIndex - 1].threshold : 0;
          const previousPosition = nextIndex > 0 ? positions[nextIndex - 1] : 0;
          const span = offers[nextIndex].threshold - previousThreshold;
          const reach = positions[nextIndex] - previousPosition;
          progressPercent =
            span > 0
              ? previousPosition + Math.min(reach, ((cartTotal - previousThreshold) / span) * reach)
              : positions[nextIndex];
        }

        let message;
        if (!allReached) {
          // Just the next thing to aim for, rather than stacking "X unlocked — $Y to Z!" into
          // one longer sentence.
          message = 'You’re only ' + fmt(offers[nextIndex].threshold - cartTotal) + ' away from ' + offers[nextIndex].label + '!';
        } else if (offers.length <= 2) {
          message = String.fromCodePoint(0x1f389) + ' ' + offers.map((offer) => offer.label).join(' + ') + ' unlocked!';
        } else {
          // Three labels joined with " + " overflows the drawer width and stops being readable.
          message = String.fromCodePoint(0x1f389) + ' All rewards unlocked!';
        }

        this.classList.toggle('pk-shipping-bar--complete', allReached);
        // How many checkpoints are behind the buyer, for anything that wants to style on it.
        this.dataset.reached = String(allReached ? offers.length : nextIndex);

        this._els.message.textContent = message;
        this._els.fill.style.width = progressPercent + '%';
        offers.forEach((offer, index) => {
          this._setDot(this._els.dots[index], allReached || index < nextIndex);
          this._els.labels[index].textContent = offer.label;
        });
      }
    }

    customElements.define('pk-shipping-bar', PkShippingBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-styles"] && !Shopify.designMode) return;
  try {
    /* PAINTLYKIT CUSTOM: Shopify's installments banner renders in its own shadow DOM with
     Shopify's font and a small logo. Inject a tiny style so it uses the store font and an
     Afterpay-sized logo. Wording/disclosure text is untouched. */
  (() => {
    const CSS =
      '#shopify-installments,#shopify-installments *{font-family:inherit!important}' +
      '#shopify-installments svg[class*="h-[14px]"]{height:18px!important;width:auto!important}';

    const patch = (host) => {
      const root = host.shadowRoot;
      if (!root) return;
      if (!root.querySelector('style[data-pk-installments]')) {
        const style = document.createElement('style');
        style.setAttribute('data-pk-installments', '');
        style.textContent = CSS;
        root.appendChild(style);
      }
      if (!host.__pkObserved) {
        host.__pkObserved = true;
        new MutationObserver(() => patch(host)).observe(root, { childList: true });
      }
    };

    const scan = () => document.querySelectorAll('shopify-payment-terms').forEach(patch);

    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        scan();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    customElements.whenDefined('shopify-payment-terms').then(scan);
    scan();
    setTimeout(scan, 1000);
    setTimeout(scan, 3000);
  })();
  } catch(e) { console.error(e); }
})();

})();
